/** Quebec destination cart message. Shipping checkout enforcement must be configured in Shopify admin. */
(function () {
  'use strict';
  var selector = '[data-dds-qc-destination]';
  var storageKey = 'dds_shipping_destination_province';
  function readSession() { try { return window.sessionStorage.getItem(storageKey) || ''; } catch (e) { return ''; } }
  function writeSession(v) { try { window.sessionStorage.setItem(storageKey, v); } catch (e) {} }
  function valid(v) { return /^(AB|BC|MB|NB|NL|NT|NS|NU|ON|PE|QC|SK|YT)$/.test(v); }
  function sync(province) {
    province = valid(province) ? province : '';
    document.querySelectorAll(selector).forEach(function (wrapper) {
      var select = wrapper.querySelector('[data-dds-qc-province]');
      var alert = wrapper.querySelector('[data-dds-qc-notice]');
      if (!select || !alert) return;
      if (select.value !== province) select.value = province;
      var isQuebec = province === 'QC';
      wrapper.setAttribute('data-quebec-state', isQuebec ? 'qc' : 'other');
      alert.hidden = !isQuebec;
      var form = wrapper.closest('form');
      if (form) {
        form.classList.toggle('dds-qc-checkout-blocked', isQuebec);
        form.querySelectorAll('button[name="checkout"]').forEach(function (button) {
          // Only restore buttons disabled by this widget.
          if (isQuebec) {
            if (!button.disabled) { button.disabled = true; button.dataset.ddsQcDisabled = 'yes'; }
          } else if (button.dataset.ddsQcDisabled === 'yes') {
            button.disabled = false;
            delete button.dataset.ddsQcDisabled;
          }
        });
      }
    });
  }
  function boot() {
    var wrappers = document.querySelectorAll(selector);
    if (!wrappers.length) return;
    var chosen = readSession();
    if (!valid(chosen)) {
      for (var i = 0; i < wrappers.length; i++) {
        var value = (wrappers[i].dataset.defaultProvince || '').toUpperCase();
        if (valid(value)) { chosen = value; break; }
      }
    }
    sync(chosen);
  }
  document.addEventListener('change', function (ev) {
    if (ev.target.matches('[data-dds-qc-province]')) {
      var value = ev.target.value;
      writeSession(value);
      sync(value);
    }
    // Keep cart destination notice consistent with shipping estimator, when supplied.
    if (ev.target.id === 'shipping-estimator-province') {
      var country = document.getElementById('shipping-estimator-country');
      var value = ev.target.value;
      // Shopify shipping estimator can use province names rather than ISO codes.
      if (/^qu[eé]bec$/i.test(value)) value = 'QC';
      if (country && country.value === 'Canada' && valid(value)) {
        writeSession(value);
        sync(value);
      }
    }
  });
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form.matches('form.cart-recap, form#mini-cart')) return;
    if (!form.classList.contains('dds-qc-checkout-blocked')) return;
    var submitter = ev.submitter;
    if (submitter && submitter.name === 'checkout') {
      ev.preventDefault();
      var select = form.querySelector('[data-dds-qc-province]');
      if (select) select.focus();
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Mini-cart is AJAX-rendered, so initialize newly added province selectors without replacing app functionality.
  var scheduled = false;
  var observer = new MutationObserver(function (mutations) {
    if (scheduled) return;
    var found = mutations.some(function (m) {
      return Array.prototype.some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 && (n.matches && n.matches(selector) || n.querySelector && n.querySelector(selector));
      });
    });
    if (found) {
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; boot(); });
    }
  });
  function observe() { if (document.body) observer.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
})();
